import { v4 as uuidv4 } from 'uuid';
import { FileState, FileWithState } from '@realtyka/real-ui';
import { FileReference } from '../openapi/atlantis';
import { DropboxResponse, FileResponse } from '../openapi/dropbox';

export const getDropboxFilesFromFileReferences = (
  fileReferences: FileReference[],
  dropbox: DropboxResponse,
) => {
  const allDropboxFiles = dropbox?.files;
  let dropboxFiles: FileResponse[] = [];
  fileReferences?.forEach((fileReference) => {
    const dropboxFile = allDropboxFiles?.find(
      (file) => file.id === fileReference.fileId,
    );
    if (dropboxFile) {
      dropboxFiles.push(dropboxFile);
    }
  });

  return dropboxFiles;
};

export const convertFileToFileResponse = (file: any): FileResponse => {
  return {
    id: file?.id,
    filename: file?.name,
    createdAt: Date.now(),
    length: file?.size,
  };
};

export const convertFileResponseToFileWithState = (
  fileResponse: FileResponse,
): FileWithState => {
  // Create a blob with actual content size if available
  const size = fileResponse.length || 1; // Use 1 byte minimum to avoid zero-size issues
  const blob = new Blob([new ArrayBuffer(size)], {
    type: 'application/octet-stream',
  });
  const baseFile = new File([blob], fileResponse.filename || 'file', {
    lastModified: fileResponse.createdAt || Date.now(),
  });

  // Create FileWithState using Object.assign
  // Ensure unique ID by adding timestamp and random suffix if no ID exists
  const uniqueId =
    fileResponse.id ||
    `${fileResponse.filename || 'file'}_${Date.now()}_${uuidv4()}`;

  return Object.assign(baseFile, {
    id: uniqueId,
    state: 'uploaded' as FileState, // Mark as uploaded since it's from Dropbox
    isExistingFile: true, // Prevent re-upload
  }) as FileWithState;
};

export const fileWithState = (file: File, state: FileState) => {
  return Object.assign(file, {
    id: `${file.name}_${Date.now()}_${uuidv4()}`,
    state: state,
  }) as FileWithState;
};
